import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Checkbox,

} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const toppingOptions = [
  "Honey",
  "Almonds",
  "Strawberry",
  "Blueberry",
  "Granola",
  "Choco Chips",
];

const quantityOptions = ["100g Cup", "150g Cup", "200g Cup"];

const AddReadyMadeYoghurt = () => {
  const navigate = useNavigate();

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [title, setTitle] = useState("");
  const [quantity, setQuantity] = useState("");
  const [toppings, setToppings] = useState<string[]>([]);
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [tax, setTax] = useState("");



  const handleToppingsChange = (event: SelectChangeEvent<typeof toppings>) => {
    const {
      target: { value },
    } = event;
    setToppings(typeof value === "string" ? value.split(",") : value);
  };



  const handleSubmit = () => {
    const data = {
      image,
      title,
      quantity,
      toppings,
      description,
      price,
      tax,
      visible: true,
    };


    navigate("/manage-readymade-yoghurt");
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Ready-Made Yoghurt</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-readymade-yoghurt")}>
            Ready Made Yoghurt
          </button>
          - Add Yoghurt
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <div className="gap_p">
                <div className="control_group w_33">
                  <label>Upload Image</label>
                  {image ? (
                    <div className="upload_image v2 no_radius">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia component="img" image={image} alt="Uploaded" />
                        </figure>
                        <IconButton
                          aria-label="Remove"
                          onClick={() => {
                            setImage("");
                            setFileName("");
                          }}
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    <label className="upload_image v2 no_radius" htmlFor="fileUpload">
                      <Input
                        id="fileUpload"
                        sx={{ display: "none" }}
                        type="file"
                        inputProps={{ accept: "image/png,image/jpeg" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = event.target.files;
                          if (files && files[0].type.includes("image")) {
                            setFileName(files[0].name);
                            setImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt="placeholder"
                          />
                        </figure>
                      </span>
                    </label>
                  )}
                </div>

              </div>
            </div>


            <div className="control_group w_33">
              <label>Name</label>
              <TextField
                fullWidth
                placeholder="Enter yoghurt name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>


            <div className="control_group w_33">
              <label>Select Quantity</label>
              <Select
                fullWidth
                value={quantity}
                displayEmpty
                onChange={(e: SelectChangeEvent) =>
                  setQuantity(e.target.value as string)
                }
              >
                <MenuItem disabled value="">
                  Select Quantity
                </MenuItem>
                {quantityOptions.map((q) => (
                  <MenuItem key={q} value={q}>
                    {q}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="control_group w_33">
              <label>Select Toppings</label>

              <Select
                fullWidth
                multiple
                value={toppings}
                onChange={handleToppingsChange}
                displayEmpty
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <span>Select Toppings</span>;
                  }
                  return selected.join(", ");
                }}
                MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
              >
                <MenuItem disabled value="">
                  Select Toppings
                </MenuItem>
                {toppingOptions.map((top) => (
                  <MenuItem key={top} value={top}>
                    <Checkbox checked={toppings.includes(top)} />
                    {top}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="control_group w_33">
              <label>Select Flavor</label>

              <Select
                fullWidth
                multiple
                value={toppings}
                onChange={handleToppingsChange}
                displayEmpty
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <span>Select Flavor</span>;
                  }
                  return selected.join(", ");
                }}
                MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
              >
                <MenuItem disabled value="">
                  Select Flavor
                </MenuItem>
                {toppingOptions.map((top) => (
                  <MenuItem key={top} value={top}>
                    <Checkbox checked={toppings.includes(top)} />
                    {top}
                  </MenuItem>
                ))}
              </Select>
            </div>


            <div className="control_group w_100">
              <label>Description</label>
              <TextField
                minRows={4}
                multiline
                fullWidth
                placeholder="Write something delicious..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>


            <div className="gap_p">
              <div className="control_group w_50">
                <label>Enter Price</label>
                <TextField
                  fullWidth
                  placeholder="Ex: 150"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>

              <div className="control_group w_50">
                <label>Tax (if any)</label>
                <TextField
                  fullWidth
                  placeholder="Ex: 5%"
                  value={tax}
                  onChange={(e) => setTax(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddReadyMadeYoghurt;
